export const TableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: 'Código',
                    type: 'text',
                    key: 'id',
                    isVisible: true,
                },
                {
                    title: 'Nombre',
                    type: 'text',
                    key: 'name',
                    isVisible: true,
                },
                {
                    title: 'Monto',
                    type: 'custom-html',
                    key: 'amount',
                    isVisible: true,
                    modifier: (item)=>{
                        const number = Number(item);
                        return `<span>${number.toLocaleString(
                            'en-US', 
                            {style: 'currency',currency: 'USD', minimumFractionDigits: 2})}</span>`;
                    }
                },
                {
                    title: 'Estado',
                    type: 'custom-html',
                    key: 'is_active',
                    isVisible: true,
                    modifier: (item) => {
                        let className = 'success';
                        let status = 'Activo';
                        if (item == 0) {
                            className = 'danger';
                            status = 'Inactivo';
                        }
                        return `<span class="badge badge-sm badge-pill badge-${className}">${status}</span>`;
                    }
                }
            ],
            actionObj: {
                title: 'Acciones',
                type: 'action',
            }
        }
    },
}